import React, { useEffect, useState } from "react";
import { encryptPassword } from "../util/util";
import axiosInstance from "../service/axios";
import { API_path } from "../service/apiPath";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LoginForm = () => {
  const lsUserVO = process.env.REACT_APP_LS_USER_VO;
  const pimsUserVO = JSON.parse(localStorage.getItem(lsUserVO));
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoggedin, setIsLoggedin] = useState(!!pimsUserVO?.isLoggedin);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedin) {
      navigate("/");
    }
  }, [isLoggedin, navigate]);
  const onFinish = async () => {
    const loginDTO = {
      userName: email,
      password: encryptPassword(password),
    };
    try {
      const response = await axiosInstance.post(API_path.login, loginDTO);
      const responseData = response.data;
      if (responseData && responseData.status) {
        const userVO = responseData.paramObjectsMap.userVO;
        const pimsUserVO = {
          userName: userVO.userName,
          loginStatus: true,
          token: userVO.token,
          tokenId: userVO.tokenId,
          userId: userVO.userId,
          phoneNumber: userVO.phoneNumber,
          pharmacyName: userVO.pharmacyName,
          pharmacyLogoURL: userVO.pharmacyLogoURL,
          email: userVO.email,
          role: userVO.role,
          isLoggedin: true,
          branchId:userVO.branchId,
          orgId:userVO.orgId
        };
        localStorage.setItem(lsUserVO, JSON.stringify(pimsUserVO));
        // toast.success(responseData.paramObjectsMap.message);
        setIsLoggedin(true);
      } else {
        toast.error(responseData.paramObjectsMap.errorMessage);
      }
    } catch (error) {
      console.log(error.message);
      toast.error("An error occurred while logging in.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please fill in all fields.");
      return;
    }
    setError(""); // Clear any existing errors

    onFinish();
  };

  const handleForgotPassword = () => {
    console.log("Forgot Password clicked");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="min-h-screen bg-green-200 flex items-center justify-center">
      <div className="w-full max-w-lg mx-auto bg-green-100 p-8 sm:p-10 rounded-md shadow-md">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6 sm:mb-8">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6 sm:mb-8">
            <label
              className="block text-lg font-medium mb-3 sm:mb-4"
              htmlFor="email"
            >
              Email
            </label>
            <input
              className="w-full p-3 sm:p-4 border border-gray-300 rounded-md text-lg"
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6 sm:mb-8 relative">
            <label
              className="block text-lg font-medium mb-3 sm:mb-4"
              htmlFor="password"
            >
              Password
            </label>
            <input
              className="w-full p-3 sm:p-4 border border-gray-300 rounded-md text-lg"
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute right-3 top-3 sm:top-4 text-gray-600"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
          {error && (
            <div className="mb-6 sm:mb-8 text-red-600 text-lg font-medium">
              {error}
            </div>
          )}
          <button
            className="w-full bg-green-700 text-white px-4 py-3 sm:py-4 rounded-md text-lg hover:bg-green-600"
            type="submit"
          >
            Login
          </button>
        </form>
        <div className="mt-6 sm:mt-8 text-center">
          <button
            className="text-blue-700 hover:text-blue-900"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
